import {
  ControlcenterMelcoModelsSupplierProduct,
  SuppliersApi,
  useAPIAction,
} from "melco-shared-logic";
import { useFormikContext } from "formik";
import { QueryObserverResult } from "react-query";
import { useState } from "react";
import { supplierProductToInitialValues } from "../../components/supplierproducts/form/SupplierProductEditForm";

export const useRevertSupplierProduct = (
  supplierProductId: string,
  refetch: () => Promise<
    QueryObserverResult<ControlcenterMelcoModelsSupplierProduct, unknown>
  >
) => {
  const dateOfLastRevert = new Date().getTime();
  const [revertKey, setRevertKey] = useState(dateOfLastRevert);
  const { resetForm } = useFormikContext();

  return [
    ...useAPIAction(
      SuppliersApi,
      async (api) => {
        const data = await api.supplierProductRevert({
          id: supplierProductId,
        });

        return {
          successMessages: [
            {
              message: "default",
            },
          ],
          data,
        };
      },
      {
        translationPrefix: "supplierproducts.actions.revert",
        onSuccess: async () => {
          const refetchResult = await refetch();

          resetForm({
            values: refetchResult.data
              ? supplierProductToInitialValues(refetchResult.data)
              : {},
          });

          // wait until formik values have changed
          await Promise.resolve();

          // trigger re-initialization of renderer
          const dateOfRevert = new Date().getTime();
          setRevertKey(dateOfRevert);
        },
      }
    ),
    revertKey,
  ] as const;
};
